import React from 'react';
import SiteHeader from 'components/SiteHeader';
import { Link } from 'react-router-dom'; // Link'i içeri aktardık

export default function TeslimatIade() {
    return (
        <div className="min-h-screen bg-background text-foreground">
            <SiteHeader />
            <div className="h-16 md:h-20"></div>

            <main className="container mx-auto max-w-3xl px-4 py-12 md:py-16">

                <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-neutral-900 mb-8">
                    Teslimat ve İade Şartları
                </h1>

                <p className="text-sm text-neutral-500 mb-8">
                    Bu şartlar, Anora Forever'dan satın aldığınız dijital hizmetlerin teslimat ve iade süreçlerini düzenler.
                </p>

                <div className="space-y-8 text-neutral-700 leading-relaxed">

                    <section>
                        <h2 className="text-xl font-semibold text-neutral-800 mb-3">
                            1. Hizmetin Teslimat Esasları (Dijital Ürün)
                        </h2>
                        <ul className="list-disc list-inside space-y-2 pl-4">
                            <li>Hizmetin Niteliği: Anora Forever tarafından sunulan hizmetler, elektronik ortamda anında ifa edilen dijital ürün/hizmet kategorisindedir.</li>
                            <li>Teslimat Süreci: Yazılım hizmetinin teslimatı, satın alma işleminin tamamlanması ve ödeme onayının alınmasının ardından en geç 1  gün içinde mail aracılığı ile iletilir. Baskı ürünlerinin teslimatı ise anlaşmalı baskı yerlerimiz aracılığı ile satın alırken girdiğiniz adres veya organizasyona 7-10 iş günü içinde gerçekleştirilir.</li>
                            <li>Aktivasyon: Aktivasyon işlemi, ödemenin başarılı bir şekilde gerçekleşmesini takip eden 1 (bir) gün içinde tamamlanır. Aktivasyon sonrasında, müşteriye özel etkinlik sayfası ve yükleme araçları kullanıma açılır.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-neutral-800 mb-3">
                            2. Cayma Hakkı ve Özel İade Şartları
                        </h2>

                        <p className="font-semibold text-neutral-800">2.1 Yasal Cayma Hakkı İstisnası</p>
                        <p className="text-sm border-l-4 border-rose-300 pl-3 italic">
                            Tüketicinin Korunması Hakkında Kanun ve ilgili Mesafeli Sözleşmeler Yönetmeliği (Madde 15/ğ) uyarınca, elektronik ortamda anında ifa edilen hizmetler ve tüketiciye anında teslim edilen gayri maddi mallara ilişkin sözleşmelerde yasal **cayma hakkı bulunmamaktadır.**
                        </p>

                        <p className="font-semibold text-neutral-800 pt-3">2.2 Anora Forever Özel İade Politikası</p>
                        <p>
                            Yukarıdaki yasal istisnaya rağmen, Anora Forever müşteri memnuniyeti kapsamında aşağıdaki durumlarda **satın alma tarihinden itibaren 14 (on dört) takvim günü içinde** iade hakkı tanımaktadır:
                        </p>
                        <ul className="list-disc list-inside space-y-2 pl-6 pt-2">
                            <li>Müşterinin dijital ürünün kullanımından vazgeçmesi (hizmetin 10 gb veri yükleme sınırını aşmamış olması koşuluyla).</li>
                            <li>Hizmetin sunulacağı organizasyonun resmi olarak iptal edilmesi.</li>
                            <li>Hizmetin taahhüt edilen temel işlevlerini yerine getiremeyecek ölçüde teknik bir kusurun bulunması ve bu kusurun teknik destek ekibimizce 48 saat içinde giderilememesi.</li>
                        </ul>

                        <p className="pt-3">
                            İade talepleri, Hizmet Sahibinin info@anoraforever.com adresine e-posta göndermesi veya <Link to="/iletisim" className="text-rose-600 hover:underline font-medium">İletişim Sayfası</Link> üzerinden başvuru yapması ile başlatılır.
                        </p>

                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-neutral-800 mb-3">
                            3. İptal ve İade Prosedürü
                        </h2>
                        <p>
                            Aktivasyon Öncesi: Eğer ödeme yapıldıktan sonra hizmet aktivasyonu henüz gerçekleşmemişse, Müşteri Hizmetlerimiz ile iletişime geçilerek iptal süreci derhal başlatılabilir.
                        </p>
                        <p>
                            İade Süreci: Onaylanan iade ve iptal taleplerinde, ödeme tutarı yasal azami süre olan 14 gün içinde, ancak genellikle yedi (7) iş günü içinde ödemenin yapıldığı orijinal yöntemle (kredi kartına iade/banka hesabına transfer) iade edilir.
                        </p>
                    </section>
                </div>
            </main>
        </div>
    );
}